// Project Imports
import Product from 'constants/ProductConstants';

const fetchSpecialExitBenefit = (solutionData) => {
    let specialExitBenefitList = []

    solutionData.coverage.forEach((coverage) => {
        coverage.life_assured_list.forEach(lifeAssured => {
            lifeAssured.product_details.forEach(obj => {
                let specialExitBenefit = "YES"
                let benefitMessage = ""
                switch (obj.product_name) {
                    case Product.ZINDAGI_PROTECT:   
                    if (specialExitBenefit) {
                        let speicalExitBenefitYear = obj.data.OutputJSON[0][0].YEAR_SPECIAL_EXIT_BENEFIT
                            benefitMessage =`Option to surrender and get all Premiums paid towards life cover and premium break benefit back at ${speicalExitBenefitYear}th Policy year` 
                            if (!checkBenefitAvailable(benefitMessage, specialExitBenefitList))
                                specialExitBenefitList.push(benefitMessage)
                        }
                        break;
                }
            })
        })
    })
    return specialExitBenefitList
}

const fetchInputStringOpt = (key, inputString) => {
    return inputString.filter((item) => item.Key == key)[0]?.Value || 'NO'
}

const checkBenefitAvailable = (benefit, coverList) => {
    return coverList.some((item) => item === benefit)
}

export default fetchSpecialExitBenefit